import React, { useState } from 'react'
import commonStyles from '../commonStyles.module.css'
import styles from './CollapseModern.module.css'

function CollapseModern({ title, children, onOpen = false }) {
  
    const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
    if (onOpen) {
      onOpen(isOpen);
    }
  };
  
    return (
    <div>
      <button type="button" className={`${commonStyles.collapsible}  ${commonStyles.btn} ${commonStyles.btnPrimary}`} onClick={toggleCollapse}>
        {title}
        <span style={{ marginLeft: 8 }}>
          {isOpen ? "▲" : "▼"}
        </span>
      </button>
      {isOpen && (
        <div className={commonStyles.collapsibleContent}>
          {children}
        </div>
      )}
    </div>
  )
}

export default CollapseModern